import styled, { css } from 'styled-components';

import Button from 'src/app/components/Elements/Button';
import { Typography } from 'src/app/components/Elements/Typography';
import type { ThemeSpaceType } from 'src/styles/theme';

export const ZipCheckWrapper = styled('div')<{ largerWidth: boolean; marginTop?: ThemeSpaceType }>`
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  max-width: ${props => (props.largerWidth ? '57.2rem' : '48rem')};
  & > div {
    flex: 1 1 auto;
  }
  margin-top: ${props => (props.marginTop ? props.theme.space[props.marginTop] : 'inherit')};
`;

export const ZipCheckButton = styled(props => <Button {...props} />)`
  &&& {
    height: ${props => props.theme.space.s7};
    margin-left: ${props => props.theme.space.s7};
    ${props => props.theme.mediaQueries.smallDown} {
      margin-left: ${props => props.theme.space.s5};
    }
    margin-top: 2rem;
    ${props => props.theme.colors[props.bgColor] && `background: ${props.theme.colors[props.bgColor]}`} !important
  }
`;

export const SuccessCTATextButton = styled(props => <Button {...props} />)`
  &&& {
    ${props => props.theme.colors[props.bgColor] && `background: ${props.theme.colors[props.bgColor]}`} !important
  }
`;

export const SuccessBody = styled(props => <Typography {...props} />)`
  font-weight: ${props => props.theme.fontWeights.book} !important;
  max-width: 64rem;
`;

export const TryAgainButton = styled(props => <Button {...props} />)`
  &&& {
    display: inline-flex;
    align-items: center;
    text-decoration: white;
    padding: ${props => props.theme.space.none};
    margin: ${props => props.theme.space.none} ${props => props.theme.space.none} ${props => props.theme.space.s5};
    background-color: transparent;
    & > svg {
      margin-right: ${props => props.theme.space.s3};
      width: ${props => props.theme.space.s3};
      height: ${props => props.theme.space.s3};
      & path {
        fill: white !important;
      }
    }
  }
`;

export const FadeInText = styled.span`
  ${props => css`
    animation-name: ${props.theme.animations.fadeIn};
    animation-duration: ${props.theme.animationDurations[500]};
  `}
`;

export const InlineBlockContent = styled.span`
  display: inline-block;
`;

export const CardContent = styled.div`
  padding: ${props => props.theme.space.s5};
  display: flex;
  align-items: center;
  & svg {
    margin-right: ${props => props.theme.space.s2};
    & path {
      fill: ${props => props.theme.colors.capsuleGreen50};
    }
  }
`;
